var poll_header_default = {
  "title": "MDBsk",
  "image": "IvM4b",
  "webview": "M1XX4"
};
export {
  poll_header_default as default
};
//# sourceMappingURL=poll-header-scss.js.map
